/// <reference types="./proposal.d.mts" />
import * as $endpoints from "../../../app_config/app_config/endpoints.mjs";
import * as $sentry from "../../../app_config/sentry.mjs";
import * as $proposal from "../../../common/data/proposal.mjs";
import { Proposal } from "../../../common/data/proposal.mjs";
import * as $iso639 from "../../../common/data/translate/language/iso639.mjs";
import * as $unsafe from "../../../common_common/gleam/unsafe.mjs";
import * as $file from "../../../ds/web/browser/file.mjs";
import * as $global from "../../../ds/web/javascript/global.mjs";
import * as $fetch from "../../../gleam_fetch/gleam/fetch.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $request from "../../../gleam_http/gleam/http/request.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $level from "../../../grille_pain/grille_pain/toast/level.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import * as $state from "../../data/model/state.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $ask from "../../frontend/ask.mjs";
import * as $dom from "../../frontend/effects/dom.mjs";
import * as $error from "../../frontend/error.mjs";
import * as $middleware from "../../frontend/middleware.mjs";
import { Ok, Error, toList, makeError } from "../../gleam.mjs";
import { focusInput as focus_input } from "./dom.ffi.ts";

const FILEPATH = "src/frontend/effects/proposal.gleam";

export function download_proposal(
  state,
  proposal_id,
  toast_id,
  project_name,
  proposal_type
) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let url = $endpoints.heimdall();
              let language = $iso639.to_string(state.language);
              let _block;
              let _block$1;
              if (proposal_type instanceof $proposal.Document) {
                _block$1 = toList([
                  url,
                  "proposals",
                  proposal_id,
                  "export",
                  "doc",
                ]);
              } else if (proposal_type instanceof $proposal.Questionnaire) {
                _block$1 = toList([
                  url,
                  "proposals",
                  proposal_id,
                  "export",
                  language,
                  "sheets",
                ]);
              } else {
                _block$1 = toList([]);
              }
              let _pipe = _block$1;
              _block = $string.join(_pipe, "/");
              let url$1 = _block;
              let $ = $request.to(url$1);
              if (!($ instanceof Ok)) {
                throw makeError(
                  "let_assert",
                  FILEPATH,
                  "frontend/effects/proposal",
                  109,
                  "download_proposal",
                  "Pattern match failed, no pattern matched the value.",
                  {
                    value: $,
                    start: 3182,
                    end: 3222,
                    pattern_start: 3193,
                    pattern_end: 3204
                  }
                )
              }
              let request = $[0];
              let _block$2;
              if (project_name === "") {
                _block$2 = "Untitled";
              } else {
                let name = project_name;
                _block$2 = name;
              }
              let file_name = _block$2;
              let authorization = "Bearer " + access_token;
              let _pipe$1 = request;
              let _pipe$2 = $request.set_header(
                _pipe$1,
                "authorization",
                authorization,
              );
              let _pipe$3 = $request.set_method(_pipe$2, new $http.Get());
              let _pipe$4 = $fetch.send(_pipe$3);
              let _pipe$5 = $promise.try_await(_pipe$4, $fetch.read_bytes_body);
              let _pipe$6 = $promise.map(
                _pipe$5,
                (_capture) => {
                  return $result.map_error(
                    _capture,
                    (var0) => { return new $error.FetchError(var0); },
                  );
                },
              );
              let _pipe$7 = $promise.map(
                _pipe$6,
                (r) => {
                  if (r instanceof Ok) {
                    let response = r[0];
                    if (response.status === 500) {
                      return new Error(
                        new $error.HttpError(
                          500,
                          "Error while exporting proposal",
                        ),
                      );
                    } else {
                      return r;
                    }
                  } else {
                    return r;
                  }
                },
              );
              let _pipe$8 = $promise.tap(
                _pipe$7,
                (dyn) => {
                  let file_name$1 = $string.replace(file_name, "xlsx", "zip");
                  let _block$3;
                  let $1 = $string.ends_with(file_name$1, ".zip");
                  if ($1) {
                    _block$3 = file_name$1;
                  } else {
                    _block$3 = file_name$1 + ".zip";
                  }
                  let file_name$2 = _block$3;
                  if (dyn instanceof Ok) {
                    let response = dyn[0];
                    return $file.download(file_name$2, response.body);
                  } else {
                    return $promise.resolve(undefined);
                  }
                },
              );
              return $promise.map(
                _pipe$8,
                (dyn) => {
                  let $1 = $result.is_ok(dyn);
                  if ($1) {
                    dispatch(new $msg.ApplicationRequestedToHideToast(toast_id));
                    let msg = "File downloaded successfully!";
                    $global.set_timeout(
                      1000,
                      () => {
                        return dispatch(
                          new $msg.ApplicationRequestedToDisplayToast(
                            new $level.Success(),
                            msg,
                          ),
                        );
                      },
                    )
                  } else {
                    let $2 = $sentry.capture(dyn);
                    
                    dispatch(new $msg.ApplicationRequestedToHideToast(toast_id));
                    let _block$3;
                    if (proposal_type instanceof $proposal.Document) {
                      _block$3 = "Can't export this word document due to legacy issues with word, please reach out to Steerlab for help.";
                    } else if (proposal_type instanceof $proposal.Questionnaire) {
                      _block$3 = "Impossible to download the file. Please, retry later.";
                    } else {
                      _block$3 = "Can't export this file format, it is not supported.";
                    }
                    let msg = _block$3;
                    $global.set_timeout(
                      1000,
                      () => {
                        return dispatch(
                          new $msg.ApplicationRequestedToDisplayToast(
                            new $level.Error(),
                            msg,
                          ),
                        );
                      },
                    )
                  }
                  return new Ok(undefined);
                },
              );
            },
          );
        },
      );
    },
  );
}

export function fetch_proposals(_) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let _pipe = $ask.to(new $ask.Heimdall(), toList(["proposals"]));
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.expect(
                _pipe$1,
                $decode.list($proposal.decoder()),
              );
              let _pipe$3 = $ask.notify(
                _pipe$2,
                (p) => {
                  return dispatch(
                    new $msg.Proposal(new $msg.ApiReturnedProposals(p, false)),
                  );
                },
              );
              return $ask.run(_pipe$3);
            },
          );
        },
      );
    },
  );
}

function require_proposal(state, proposal_id, next) {
  let $ = $list.key_find(state.proposals.all, proposal_id);
  if ($ instanceof Ok) {
    let proposal = $[0];
    return next(proposal);
  } else {
    return $effect.none();
  }
}

export function delete_proposal(state, proposal_id) {
  return $middleware.require_access_token(
    (access_token) => {
      return require_proposal(
        state,
        proposal_id,
        (_use0) => {
          let id = _use0.id;
          let pid = _use0.project_id;
          return $effect.from(
            (dispatch) => {
              return $function.tap(
                undefined,
                (_) => {
                  let at = toList(["proposals", proposal_id]);
                  let _pipe = $ask.to(new $ask.Heimdall(), at);
                  let _pipe$1 = $ask.via(_pipe, new $http.Delete());
                  let _pipe$2 = $ask.bearing(_pipe$1, access_token);
                  let _pipe$3 = $ask.run(_pipe$2);
                  return $promise.await$(
                    _pipe$3,
                    (_) => {
                      let _block;
                      let _pipe$4 = state.proposals.all;
                      let _pipe$5 = $list.filter(
                        _pipe$4,
                        (p) => {
                          return (p[1].project_id === pid) && (p[1].id !== id);
                        },
                      );
                      _block = $list.is_empty(_pipe$5);
                      let no_projects_proposals = _block;
                      if (no_projects_proposals) {
                        let _pipe$6 = $ask.to(
                          new $ask.Heimdall(),
                          toList(["projects", pid]),
                        );
                        let _pipe$7 = $ask.via(_pipe$6, new $http.Delete());
                        let _pipe$8 = $ask.bearing(_pipe$7, access_token);
                        let _pipe$9 = $ask.notify(
                          _pipe$8,
                          (_) => {
                            return dispatch(
                              new $msg.Project(new $msg.ApiDeletedProject(pid)),
                            );
                          },
                        );
                        return $ask.run(_pipe$9);
                      } else {
                        return $promise.resolve(
                          new Ok($unsafe.coerce(undefined)),
                        );
                      }
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function delete_element_in_proposal(state, proposal_id, element_id) {
  return $middleware.require_access_token(
    (access_token) => {
      return require_proposal(
        state,
        proposal_id,
        (_) => {
          return $effect.from(
            (_) => {
              return $function.tap(
                undefined,
                (_) => {
                  let at = toList([
                    "proposals",
                    proposal_id,
                    "elements",
                    element_id,
                  ]);
                  let _pipe = $ask.to(new $ask.Heimdall(), at);
                  let _pipe$1 = $ask.via(_pipe, new $http.Delete());
                  let _pipe$2 = $ask.bearing(_pipe$1, access_token);
                  return $ask.run(_pipe$2);
                },
              );
            },
          );
        },
      );
    },
  );
}

export function update_proposal(
  state,
  id,
  only_status,
  retrigger_questions,
  override_validated
) {
  return $middleware.require_access_token(
    (access_token) => {
      return require_proposal(
        state,
        id,
        (proposal) => {
          return $effect.from(
            (dispatch) => {
              return $function.tap(
                undefined,
                (_) => {
                  let _block;
                  if (only_status) {
                    _block = toList(["proposals", id, "status"]);
                  } else {
                    _block = toList(["proposals", id]);
                  }
                  let at = _block;
                  let _pipe = $ask.to(new $ask.Heimdall(), at);
                  let _pipe$1 = $ask.bearing(_pipe, access_token);
                  let _pipe$2 = $ask.via(_pipe$1, new $http.Patch());
                  let _pipe$3 = $ask.with$(
                    _pipe$2,
                    $json.object(
                      toList([
                        ["proposal", $proposal.encode(proposal)],
                        ["retrigger_questions", $json.bool(retrigger_questions)],
                        ["override_validated", $json.bool(override_validated)],
                      ]),
                    ),
                  );
                  let _pipe$4 = $ask.expect(
                    _pipe$3,
                    $decode.at(toList(["proposal"]), $proposal.decoder()),
                  );
                  let _pipe$5 = $ask.notify(
                    _pipe$4,
                    (q) => {
                      return dispatch(
                        new $msg.Proposal(
                          new $msg.ApiReturnedProposals(toList([q]), true),
                        ),
                      );
                    },
                  );
                  $ask.run(_pipe$5)
                  return undefined;
                },
              );
            },
          );
        },
      );
    },
  );
}

export function unsubscribe_previous_dom_click(state) {
  let _pipe = state.dropdown_unsubscriber;
  return $option.unwrap(_pipe, $effect.none());
}

export function subscribe_dom_click(state) {
  return $effect.batch(
    toList([
      unsubscribe_previous_dom_click(state),
      (() => {
        let $ = $state.should_subscribe_dom_click(state);
        if ($) {
          let _pipe = $dom.on_click(
            new $msg.Proposal(new $msg.UserClickedOutsideInProposal()),
          );
          let _pipe$1 = $dom.to_cancel(
            _pipe,
            (var0) => { return new $msg.ProposalReturnedUnsubscriber(var0); },
          );
          let _pipe$2 = $dom.once(_pipe$1);
          return $dom.subscribe(_pipe$2);
        } else {
          return $effect.none();
        }
      })(),
    ]),
  );
}

export function focus_comment_reply(target_id) {
  focus_input(target_id);
  return $effect.none();
}
